import { put, call, fork, takeMaybe } from 'redux-saga/effects'
import { filterCollaborationsService } from 'src/api/collection'
import { filterCollaborationsSuccess } from 'src/reducers/collection/action'
import { FILTER_COLLABORATION_COLLECTION_LIST } from 'src/reducers/collection/type'
import generalSaga from '../general'
import { operationSuccess, operationFail } from 'src/reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* filterCollaborationCollectionListFlow(payload) {
  try {
    const { query, callback } = payload
    const response = yield call(filterCollaborationsService, query)

    yield put(filterCollaborationsSuccess(response.data))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* filterCollaborationCollectionListWatcher() {
  while (true) {
    const action = yield takeMaybe(FILTER_COLLABORATION_COLLECTION_LIST)
    const { payload } = action

    yield fork(generalSaga, filterCollaborationCollectionListFlow, payload)
  }
}
